export const hasFeatureFlag = (state) => (flagName) => {
  if (!state.featureFlags || state.featureFlags.length === 0) {
    return false;
  }
  return state.featureFlags.includes(flagName);
};

export const isKioskUser = (state) => {
  if (state.user.isKioskUser || state.kioskUser.isKioskUser) {
    return true;
  }
  return false;
};

export const hasKioskPermission = (state) => (permission) => {
  if (!state.kioskPermissions || state.kioskPermissions.length === 0) {
    return false;
  }
  return state.kioskPermissions.some((p) => p.name === permission);
};

export const hasAnyKioskPermission = (state) => (permissions) => {
  if (!state.kioskPermissions || state.kioskPermissions.length === 0) {
    return false;
  }
  return permissions.some((permission) => state.kioskPermissions.some((p) => p.name === permission));
};

export const hasAllKioskPermissions = (state) => (permissions) => {
  if (!state.kioskPermissions || state.kioskPermissions.length === 0) {
    return false;
  }
  return permissions.every((permission) => state.kioskPermissions.some((p) => p.name === permission));
};

export const getKioskPermissionsBySection = (state) => (section) => {
  if (!state.kioskPermissions || state.kioskPermissions.length === 0) {
    return [];
  }
  return state.kioskPermissions.filter((p) => p.section === section);
};
